var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('Filters',{attrs:{"on-change":_vm.onChangeFilters,"loading":_vm.loading},on:{"filterError":_vm.onErrorFilters}}),_c('DataStats',{attrs:{"data":_vm.dataStats}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }